<template>
  <div>
    <div
      v-show="disabled"
      class="synaplus-cosmo-h-120"
      style="position: relative;"
    >
      <div class="overlay bg-darkgrey p-3">
        <div
          class="w-100 h-100 border-lightgrey bg-darkgrey text-center d-flex"
          style="box-sizing: border-box; border: dashed 4px;"
        >
          <div class="w-100 justify-content-center align-self-center">
            <span class="fa fa-upload fa-2x text-lightgrey" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="show_dropzone && !disabled"
      class="synaplus-cosmo-h-120"
      style="position: relative;"
    >
      <div class="overlay bg-lightgrey p-3">
        <div
          class="w-100 h-100 border-darkgrey bg-lightgrey text-center d-flex"
          style="box-sizing: border-box; border: dashed 4px;"
        >
          <div class="w-100 justify-content-center align-self-center">
            <span class="fa fa-upload fa-2x text-darkgrey" />
          </div>
        </div>
      </div>

      <vue-dropzone
        id="filedropzone"
        ref="filedropzone"
        class="overlay"
        :include-styling="false"
        :options="file_dropzone_options"
        @vdropzone-file-added="filedropzone_added"
        @vdropzone-removed-file="filedropzone_removed"
        @vdropzone-upload-progress="filedropzone_progress"
        @vdropzone-error="filedropzone_error"
        @vdropzone-success="filedropzone_success"
        @vdropzone-canceled="filedropzone_canceled"
        @vdropzone-sending="filedropzone_sending"
        @vdropzone-complete="filedropzone_complete"
      />
    </div>
    <div v-show="!disabled" :id="did" class="dz-preview" />
  </div>
</template>

<style scoped>
.overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
/* Hide the delete button initially */
.dz-preview >>> .delete {
  display: none;
}

/* Hide the start and cancel buttons and show the delete button */
.dz-preview >>> .dz-complete .start,
.dz-preview >>> .dz-complete .cancel {
  display: none;
}
.dz-preview >>> .dz-complete .delete {
  display: block;
}
</style>

<script>
import _ from 'lodash'
import vue2Dropzone from 'vue2-dropzone'
import moment from 'moment'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import {
  uploads_create,
  uploads_forimport_update,
} from '@/api/subscriptions.js'

export default {
  name: 'FileUploader',
  components: {
    'vue-dropzone': vue2Dropzone,
  },
  props: { project_id: undefined, disabled: { default: false } },
  data() {
    const did = 'dropzone' + _.uniqueId()
    const idref = '#' + did
    return {
      did,
      // upload_in_progress: false,
      // file_success: false,
      show_dropzone: true,
      file_dropzone_options: {
        autoQueue: false,
        url: this.filedropzone_url,
        previewTemplate: this.filedropzone_template(),
        // 24h timeout (in ms)
        timeout: 24 * 3600 * 1000,
        maxFiles: 1,
        //In megabytes
        maxFilesize: 1024 * 1024,
        previewsContainer: idref,
        method: 'put',
        sending(file, xhr) {
          // This function is used by vue-dropzone to send the data as binary
          let _send = xhr.send
          xhr.send = function() {
            _send.call(xhr, file)
          }
        },
      },
    }
  },

  methods: {
    filedropzone_url(files) {
      const token = files[0].token
      return `/api/projects/${this.project_id}/uploads/${token}/update`
    },
    async filedropzone_added(file) {
      this.update_dropzone_language()
      const self = this
      file.previewElement.querySelector('.start').onclick = function() {
        self.$refs.filedropzone.dropzone.enqueueFile(file)
      }

      file.previewElement.querySelector('.start button').disabled = true
      let dateLastModified = moment(file.lastModified)
      const token = await uploads_create(this.project_id, {
        name: file.name,
        size: file.size,
        last_modified_dt: dateLastModified,
        mime_type: file.type,
      })

      file.previewElement.querySelector('.start button').disabled = false
      file.token = token

      this.show_dropzone = this.$refs.filedropzone.getAddedFiles().length == 0
      // this.$emit('ChangesInProgressUpdate', {
      //   value: true,
      //   text: this.$t('text_upload_in_progress'),
      // })
    },
    filedropzone_complete(file) {
      // console.log('filedropzone_complete', file)
      delete file.previewElement.querySelector('.start').onclick
      // this.upload_in_progress = false
      // this.$emit('ChangesInProgressUpdate', {
      //   value: false,
      //   text: this.$t('text_upload_in_progress'),
      // })
    },
    filedropzone_error(file, err) {
      // console.log('filedropzone_error', file)
      // this.upload_in_progress = false
      // this.$emit('ChangesInProgressUpdate', {
      //   value: false,
      //   text: this.$t('text_upload_in_progress'),
      // })
    },
    filedropzone_success(file, response) {
      // console.log('filedropzone_success', file)
      // this.file_success = true
      // this.upload_in_progress = false
      // this.$emit('ChangesInProgressUpdate', {
      //   value: false,
      //   text: this.$t('text_upload_in_progress'),
      // })
      this.$emit('success', file.token)
    },
    filedropzone_removed(file) {
      // console.log('filedropzone_removed', file)
      this.show_dropzone = this.$refs.filedropzone.getAddedFiles().length == 0
      // this.upload_in_progress = false
      // this.$emit('ChangesInProgressUpdate', {
      //   value: false,
      //   text: this.$t('text_upload_in_progress'),
      // })
    },
    filedropzone_canceled(file) {
      // console.log('filedropzone_canceled', file)
      this.show_dropzone = this.$refs.filedropzone.getAddedFiles().length == 0
      // this.upload_in_progress = false
      // this.$emit('ChangesInProgressUpdate', {
      //   value: false,
      //   text: this.$t('text_upload_in_progress'),
      // })
    },
    filedropzone_progress(file, progress, bytes_sent) {
      // console.log('filedropzone_progress', file, progress, bytes_sent)
    },
    filedropzone_sending(file) {
      // console.log('filedropzone_sending', file)
      file.previewElement.querySelector('.start').disabled = true
      // this.upload_in_progress = true
      // this.$emit('ChangesInProgressUpdate', {
      //   value: true,
      //   text: this.$t('text_upload_in_progress'),
      // })
    },
    update_dropzone_language() {
      let start_upload = document.getElementById('start_upload')
      if (!_.isNil(start_upload)) {
        start_upload.innerHTML = this.$t('start')
      }
      let cancel_upload = document.getElementById('cancel_upload')
      if (!_.isNil(cancel_upload)) {
        cancel_upload.innerHTML = this.$t('cancel')
      }
      let delete_upload = document.getElementById('delete_upload')
      if (!_.isNil(delete_upload)) {
        delete_upload.innerHTML = this.$t('delete')
      }
    },
    filedropzone_template() {
      return `
          <div class="row mt-3 align-items-center">
            <div class="col-3">
              <button data-dz-remove class="cancel btn btn-secondary btn-block">
                <span id="cancel_upload"></span>
              </button>
            </div>
            <div class="col-6">
              <div class="d-flex text-left justify-content-between">
                <div>
                  <span class="name" data-dz-name></span>
                  <strong class="error text-danger" data-dz-errormessage></strong>
                </div>
                <div>
                  <span class="size" data-dz-size></span>
                </div>
              </div>
              <div class="progress">
                <div class="progress-bar bg-success"
                  role="progressbar" aria-valuemin="0" aria-valuemax="100"
                  aria-valuenow="0" data-dz-uploadprogress>
                </div>
              </div>
            </div>
            <div class="col-3 start">
              <button class="btn btn-primary btn-block">
                  <span id="start_upload"></span>
              </button>
            </div>
            <div class="col-3 delete">
              <button data-dz-remove class="btn btn-danger btn-block">
                  <span id="delete_upload"></span>
              </button>
            </div>
          </div>
          `
    },
  },
}
</script>
